import { AccountClass } from "@common/constants/domains/accounting/accounts";

export enum CoaImportStep {
    UploadDocument = "uploadDocument",
    EnterAccounts = "enterAccounts",
    MapAccounts = "mapAccounts",
}

export interface CoaAccountRow {
    id: string;
    name: string;
    accountClass: AccountClass | null;
}

export interface CoaAccountRowError {
    name?: string;
    accountClass?: string;
}

export interface CoaValidationErrors {
    accounts?: CoaAccountRowError[];
    noAccounts?: string;
}
